import { Stack, Typography } from "@mui/material";
import { BaseModuleSubtypeResponse } from "../../../../../../types/actionModule/baseModuleSubtype";
import { EventWithAnswer, SurveyAppointmentSubtypeDataModel, SurveyEventAnswer } from "../../../../../../types/actionModule/subtypes/surveyAppointmentModels";
import { useTranslation } from "react-i18next";
import DefaultIcon from "../../../../../../components/common/DefaultIcon";
import { Check, CloseOutlined } from "@mui/icons-material";
import dayjs from "dayjs";

interface Props {
    subtype: BaseModuleSubtypeResponse;
    subtypeData: SurveyAppointmentSubtypeDataModel;
}

export default function SurveyAppointmentSubtypeDetails(props: Props) {
    const { t } = useTranslation();

    if (props.subtypeData.noEventViable) {
        return <Typography textOverflow={"ellipsis"}>{t("incentivationPage.surveyAppointment.noEventSelected")}</Typography>
    }

    return <Stack direction="column" gap={1}>
        {props.subtypeData.eventAnswers.map(e => <EventAnswer event={e} />)}
    </Stack>
}

interface EventAnswerProps {
    event: EventWithAnswer;
}

const formatDateTime = (value: string) =>
    dayjs(value).format("DD.MM.YYYY HH:mm [Uhr]");

function EventAnswer(props: EventAnswerProps) {
    return <Stack direction="row" alignItems="center" gap={2}>
        <DefaultIcon
            iconName={props.event.event.iconName}
            colorHex={props.event.event.colorHex}
            iconUrl={props.event.event.iconUrl}
        />
        <Stack direction="column">
            <Typography variant="body1">{props.event.event.title}</Typography>
            <Typography variant="caption">{formatDateTime(props.event.event.startDate)}</Typography>
            {
                props.event.event.startDate != props.event.event.endDate &&
                <Typography variant="caption">{formatDateTime(props.event.event.endDate)}</Typography>
            }
        </Stack>
        {props.event.answer == SurveyEventAnswer.Accepted && <Check />}
        {props.event.answer == SurveyEventAnswer.Declined && <CloseOutlined />}
    </Stack>
}